const IMG_LIMIT = 12;

const INITIAL_STATE = {
    randomHeroHeader: 1,
};

function getRandomInitialState() {
    return {
        ...INITIAL_STATE,
        randomHeroHeader: Math.ceil(Math.random() * IMG_LIMIT),
    };
}

function reducer(state = getRandomInitialState()) {
    return state;
}

export {
    IMG_LIMIT,
    reducer,
};
export default reducer;
